import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c88919c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox__group" }
const _hoisted_2 = { class: "checkbox__item" }
const _hoisted_3 = ["aria-describedby", "aria-invalid"]
const _hoisted_4 = {
  class: "checkbox__label",
  for: "terms-of-use-checkbox"
}
const _hoisted_5 = {
  class: "btn-link-modal",
  "data-bs-toggle": "modal",
  "data-bs-target": "#btnLinkModal"
}
const _hoisted_6 = {
  class: "btn-link-modal",
  "data-bs-toggle": "modal",
  "data-bs-target": "#btnLinkModalPrivacy"
}
const _hoisted_7 = ["id"]
const _hoisted_8 = {
  class: "modal fade",
  id: "btnLinkModal",
  tabindex: "-1",
  "aria-labelledby": "btnLinkModalLabel",
  "aria-hidden": "true"
}
const _hoisted_9 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" }
const _hoisted_10 = { class: "modal-content" }
const _hoisted_11 = { class: "modal-header" }
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, null, -1))
const _hoisted_15 = {
  class: "modal fade",
  id: "btnLinkModalPrivacy",
  tabindex: "-1",
  "aria-labelledby": "btnLinkModalLabel",
  "aria-hidden": "true"
}
const _hoisted_16 = { class: "modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl" }
const _hoisted_17 = { class: "modal-content" }
const _hoisted_18 = { class: "modal-header" }
const _hoisted_19 = ["aria-label"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, null, -1))

import { useInterviewStore } from '@/stores/interviewStore'
import { computed, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TermsOfUse',
  props: {
    questionId: null
  },
  setup(__props: any) {

const interviewStore = useInterviewStore()

const isChecked = ref<boolean>(interviewStore.getCookie("termsOfUse") ? true : false)
const closeModal = ref<HTMLButtonElement>()
const cookieLiveTime = 31



const agreementText = computed(() => interviewStore.getLocalization('InterviewQuestionary.TermsOfUse.AgreementText'))
const termsOfUseButton = computed(() => interviewStore.getLocalization('InterviewQuestionary.TermsOfUse.ButtonText'))
const privacyPolicyButton = computed(() => interviewStore.getLocalization('InterviewQuestionary.TermsOfUse.PrivacyPolicyButton'))
const termsOfUse = computed(() => interviewStore.getLocalization('InterviewQuestionary.TermsOfUse'))
const privacyPolicy = computed(() => interviewStore.getLocalization('InterviewQuestionary.PrivacyPolicy'))
const modalCloseBtnLabel = computed(() => interviewStore.getLocalization('Accessability.Modal.Close'))

const termsErrorMessage = computed(() => interviewStore.questionsAnswerError["termsOfUse"])

function onAnswerChoose() {
    if (isChecked.value) {
        interviewStore.setCookie('termsOfUse', true, cookieLiveTime)
        interviewStore.setCookie('privacyPilicy', true, cookieLiveTime)
        interviewStore.questionsAnswerError["termsOfUse"] = null
    } else {
        interviewStore.eraseCookie('termsOfUse')
        interviewStore.eraseCookie('privacyPilicy')
    }

    if (closeModal.value != undefined) {
        closeModal.value.click()
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["checkbox__input", {
                    'tw-form-control__field-error--highlight': _unref(termsErrorMessage),
                }]),
          type: "checkbox",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (onAnswerChoose())),
          id: "terms-of-use-checkbox",
          name: "terms-of-use-checkbox",
          "aria-describedby": 'terms-of-use-error-' + __props.questionId,
          "aria-required": true,
          "aria-invalid": !isChecked.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isChecked).value = $event))
        }, null, 42, _hoisted_3), [
          [_vModelCheckbox, isChecked.value]
        ]),
        _createElementVNode("label", _hoisted_4, [
          _createTextVNode(_toDisplayString(_unref(agreementText)) + " ", 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(termsOfUseButton)), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(privacyPolicyButton)), 1)
        ])
      ]),
      (_unref(termsErrorMessage))
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "tw-question__error",
            id: 'terms-of-use-error-' + __props.questionId,
            role: "alert",
            "aria-live": "polite"
          }, _toDisplayString(_unref(termsErrorMessage)), 9, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              ref_key: "closeModal",
              ref: closeModal,
              "aria-label": _unref(modalCloseBtnLabel)
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("div", {
            class: "modal-body",
            innerHTML: _unref(termsOfUse)
          }, null, 8, _hoisted_13),
          _hoisted_14
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              ref_key: "closeModal",
              ref: closeModal,
              "aria-label": _unref(modalCloseBtnLabel)
            }, null, 8, _hoisted_19)
          ]),
          _createElementVNode("div", {
            class: "modal-body",
            innerHTML: _unref(privacyPolicy)
          }, null, 8, _hoisted_20),
          _hoisted_21
        ])
      ])
    ])
  ], 64))
}
}

})